export enum LocationStrategyEnum {
    HASH = 'hash',
    PATH = 'path',
}
